<script>

    import { toast } from 'bulma-toast'

    import TilService from '../$services/til.service'

    import { modalStore, eventStore } from '../stores'

    import File from '../$components/file.svelte'
    import Form from '../$components/form.svelte'
    import Button from '../$components/button.svelte'
    import ButtonSave from '../$components/button.save.svelte'
    import SelectOwners from '../$components/select.owners.svelte'

    let loading = false
    let data = {
        ownerId: '60edc374e9091e00151699c0'
    }

    async function uploadTilPricing() {

        loading = true
        const resp = await TilService.uploadTilPricing(data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        toast({message: 'Precios TIL actualizados', type: 'is-success'})

        eventStore.set('til_pricing_updated')
        modalStore.close()
    }

</script>

<Form on:submit={uploadTilPricing} {loading} >
    <div class="columns">
        <div class="column">
            <SelectOwners bind:ownerId={data.ownerId} label="Propietario" />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <File bind:file={data.pricing} />
        </div>
    </div>
    <div class="is-flex is-justify-content-flex-end is-align-items-center">
        <Button on:click={modalStore.close} text="Cancelar" icon="ban" />
        <ButtonSave icon="save" text="Subir precios" />
    </div>
</Form>
